exports.TEMP_DEV_UP = 'Temperatura del dispositivo elevada';
exports.TEMP_MOT_UP = 'Temperatura del motor elevada';
exports.VOL_RANGE = 'Voltaje fuera de rango';
exports.SOC_DOWN = 'Carga del vehículo baja';

exports.GPRS_DOWN = 'Señal del GPRS baja';
exports.GPS_RANGE = 'Satélites conectados de GPS';

exports.SPEED_UP = 'Velocidad máxima sobrepasada';
exports.ACC_UP = 'Profundidad del acelerador sobrepasada';
